import React from "react";
import ClaimButton from "@components/FlowActionButtons/ClaimButton";
import type { Task } from "@services/vesselCall/types";
import { useClaimVesselCall } from "./hooks";
import { canUserClaim } from "./utils";

interface ClaimVesselCallProps {
  refetchVesselCall: () => void;
  vesselCallFlowData?: {
    vesselCallId: string;
    task: Task | null;
    status: string;
  };
}

const LANG_BASE = "vessel-call.vessel-call-status-header";

const ClaimVesselCall: React.FC<ClaimVesselCallProps> = ({
  vesselCallFlowData,
  refetchVesselCall,
}) => {
  const { onClaimVesselCall } = useClaimVesselCall(
    vesselCallFlowData?.vesselCallId,
    refetchVesselCall,
  );

  if (!vesselCallFlowData || !vesselCallFlowData.task) {
    return null;
  }

  const isActionAvailable = canUserClaim(vesselCallFlowData.task.status, vesselCallFlowData.status);

  return (
    <ClaimButton
      langBase={LANG_BASE}
      permission="canClaimVesselCall"
      isActionAvailable={isActionAvailable}
      onClaim={onClaimVesselCall}
    />
  );
};

export default ClaimVesselCall;
